import Axios from "axios";

declare const __APP_STAGE__: string;

const reactAppStage = __APP_STAGE__;
const env = reactAppStage === "local" ? "dev" : reactAppStage;

const axiosConfig = Axios.create({
  baseURL: reactAppStage === "local" ? "http://localhost:3001/local" : `https://webform-api-${env}.consorciei.com.br`,
  timeout: (30 + 10) * 1000, // BFF Default Timeout (30s) + Additional for conection delays (10s)
  responseType: "json",
  headers: {},
});

// Add a request interceptor
axiosConfig.interceptors.request.use(
  function (_config) {
    // Do something before request is sent
    return _config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
axiosConfig.interceptors.response.use(
  function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
  },
  function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    return Promise.reject(error);
  }
);

export default axiosConfig;
